import React from 'react';
import styled from 'styled-components';

import LoginContainer from '../components/Login';

export const ScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 320px;
  height: 100vh;
  min-height: 600px;
  padding: 20px;
  background: #f0f0f0;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    min-width: unset;
  }
`;

const LoginScreen = () => (
  <ScreenWrapper>
    <LoginContainer />
  </ScreenWrapper>
);
export default LoginScreen;
